import { render, staticRenderFns } from "./PerformanceReviewReportItems.vue?vue&type=template&id=52f40c80&"
import script from "./PerformanceReviewReportItems.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewReportItems.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewReportItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports